import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointConfig } from '../common/EndpointConfig';

@Injectable({
  providedIn: 'root'
})
export class GDashboardService {

  private _ep: EndpointConfig;
   constructor(private http: HttpClient) {
    this._ep = new EndpointConfig('');
  }

  public getCountsForDashboard() {
    return this.http.get(`${this._ep.getControllerUrl('GDashboard', 'GetCountsForDashboardAsync')}`);
  }

}
